import { client } from '../client';

export const deleteDependent = async (user_id: number, dependent_id: number): Promise<void> => {
  await client.delete(`users/${user_id}/dependents/${dependent_id}`);
};
